'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('@chakra-ui/react');
var themeTools = require('@chakra-ui/theme-tools');
var anatomy = require('@chakra-ui/anatomy');

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$c =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$d = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$c = fails$d;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$c(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$b = fails$d;

var functionBindNative = !fails$b(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$1 = functionBindNative;

var call$7 = Function.prototype.call;

var functionCall = NATIVE_BIND$1 ? call$7.bind(call$7) : function () {
  return call$7.apply(call$7, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var call$6 = FunctionPrototype$1.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype$1.bind.bind(call$6, call$6);

var functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$6.apply(fn, arguments);
  };
};

var uncurryThis$a = functionUncurryThis;

var toString$2 = uncurryThis$a({}.toString);
var stringSlice$1 = uncurryThis$a(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$1(toString$2(it), 8, -1);
};

var uncurryThis$9 = functionUncurryThis;
var fails$a = fails$d;
var classof$2 = classofRaw$1;

var $Object$4 = Object;
var split = uncurryThis$9(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$a(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$2(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$2 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$1 = isNullOrUndefined$2;

var $TypeError$6 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$2 = function (it) {
  if (isNullOrUndefined$1(it)) throw $TypeError$6("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$1 = requireObjectCoercible$2;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$1(it));
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var $documentAll$1 = documentAll_1;

var documentAll$1 = $documentAll$1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$f = $documentAll$1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$e = isCallable$f;
var $documentAll = documentAll_1;

var documentAll = $documentAll.all;

var isObject$6 = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable$e(it);
};

var global$b = global$c;
var isCallable$d = isCallable$f;

var aFunction = function (argument) {
  return isCallable$d(argument) ? argument : undefined;
};

var getBuiltIn$3 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$b[namespace]) : global$b[namespace] && global$b[namespace][method];
};

var uncurryThis$8 = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$8({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$a = global$c;
var userAgent = engineUserAgent;

var process = global$a.process;
var Deno = global$a.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$9 = fails$d;
var global$9 = global$c;

var $String$5 = global$9.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$9(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$3;
var isCallable$c = isCallable$f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$c($Symbol) && isPrototypeOf$1($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$b = isCallable$f;
var tryToString = tryToString$1;

var $TypeError$5 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$2 = function (argument) {
  if (isCallable$b(argument)) return argument;
  throw $TypeError$5(tryToString(argument) + ' is not a function');
};

var aCallable$1 = aCallable$2;
var isNullOrUndefined = isNullOrUndefined$2;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$1 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable$1(func);
};

var call$5 = functionCall;
var isCallable$a = isCallable$f;
var isObject$5 = isObject$6;

var $TypeError$4 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$a(fn = input.toString) && !isObject$5(val = call$5(fn, input))) return val;
  if (isCallable$a(fn = input.valueOf) && !isObject$5(val = call$5(fn, input))) return val;
  if (pref !== 'string' && isCallable$a(fn = input.toString) && !isObject$5(val = call$5(fn, input))) return val;
  throw $TypeError$4("Can't convert object to primitive value");
};

var shared$3 = {exports: {}};

var global$8 = global$c;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$5(global$8, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$8[key] = value;
  } return value;
};

var global$7 = global$c;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$7[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$3.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.31.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible = requireObjectCoercible$2;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var uncurryThis$7 = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$7({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$6 = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$1 = uncurryThis$6(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var global$6 = global$c;
var shared$2 = shared$3.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$6.Symbol;
var WellKnownSymbolsStore = shared$2('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$8 = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn$9(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$4 = functionCall;
var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod = getMethod$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$7 = wellKnownSymbol$8;

var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$7('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$4(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$4(exoticToPrim, input, pref);
    if (!isObject$4(result) || isSymbol$1(result)) return result;
    throw $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$5 = global$c;
var isObject$3 = isObject$6;

var document$1 = global$5.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$9 = descriptors;
var fails$8 = fails$d;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$9 && !fails$8(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$8 = descriptors;
var call$3 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$8 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!call$3(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$7 = descriptors;
var fails$7 = fails$d;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$7 && fails$7(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$2 = isObject$6;

var $String$3 = String;
var $TypeError$2 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$7 = function (argument) {
  if (isObject$2(argument)) return argument;
  throw $TypeError$2($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$6 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$6 = anObject$7;
var toPropertyKey = toPropertyKey$2;

var $TypeError$1 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$6 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPropertyKey(P);
  anObject$6(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$6(O);
  P = toPropertyKey(P);
  anObject$6(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$5 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$4 = DESCRIPTORS$5 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$4 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$4 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$4 || (DESCRIPTORS$4 && getDescriptor(FunctionPrototype, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$5 = functionUncurryThis;
var isCallable$9 = isCallable$f;
var store$1 = sharedStore;

var functionToString = uncurryThis$5(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$9(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$1 = store$1.inspectSource;

var global$4 = global$c;
var isCallable$8 = isCallable$f;

var WeakMap$1 = global$4.WeakMap;

var weakMapBasicDetection = isCallable$8(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$1 = shared$3.exports;
var uid = uid$2;

var keys = shared$1('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$3 = global$c;
var isObject$1 = isObject$6;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$4;
var hasOwn$6 = hasOwnProperty_1;
var shared = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$3.TypeError;
var WeakMap = global$3.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$3(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$4 = functionUncurryThis;
var fails$6 = fails$d;
var isCallable$7 = isCallable$f;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$3 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$1;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$1 = InternalStateModule$1.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;
var stringSlice = uncurryThis$4(''.slice);
var replace = uncurryThis$4(''.replace);
var join = uncurryThis$4([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$3 && !fails$6(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (stringSlice($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String$2(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$3) defineProperty$4(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$5(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$3) defineProperty$4(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$7(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var isCallable$6 = isCallable$f;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$6(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$2 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$2;

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$1(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

var toIntegerOrInfinity = toIntegerOrInfinity$2;

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength = toLength$1;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var uncurryThis$3 = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push = uncurryThis$3([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$3;
var uncurryThis$2 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$5 = anObject$7;

var concat$1 = uncurryThis$2([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$5(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$5 = fails$d;
var isCallable$5 = isCallable$f;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$5(detection) ? fails$5(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$2 = global$c;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$4;
var defineBuiltIn$3 = defineBuiltIn$4;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$2;
  } else if (STATIC) {
    target = global$2[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$2[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$2(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$2 = descriptors;
var uncurryThis$1 = functionUncurryThis;
var call$2 = functionCall;
var fails$4 = fails$d;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$1 = toObject$3;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat = uncurryThis$1([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$4(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && $assign({ b: 1 }, $assign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$1(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || call$2(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$2 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$2({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

const flattenObject = (obj, prefix = '') => {
  const result = {};
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      const propPath = prefix ? `${prefix}.${key}` : key;
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(result, flattenObject(obj[key], propPath));
      } else {
        result[propPath] = obj[key];
      }
    }
  }
  return result;
};

const baseStyle$d = {
  px: 1,
  textTransform: 'uppercase',
  fontSize: 'xs',
  borderRadius: 'sm',
  fontWeight: 'bold'
};
const variantSolid$1 = props => {
  const {
    colorScheme: c,
    theme
  } = props;
  const dark = themeTools.transparentize(`${c}.500`, 0.6)(theme);
  return {
    bg: themeTools.mode(`${c}.500`, dark)(props),
    color: themeTools.mode(`white`, `whiteAlpha.800`)(props)
  };
};
const variantSubtle = props => {
  const {
    colorScheme: c,
    theme
  } = props;
  const darkBg = themeTools.transparentize(`${c}.200`, 0.16)(theme);
  return {
    bg: themeTools.mode(`${c}.100`, darkBg)(props),
    color: themeTools.mode(`${c}.800`, `${c}.200`)(props)
  };
};
const variantOutline$2 = props => {
  const {
    colorScheme: c,
    theme
  } = props;
  const darkColor = themeTools.transparentize(`${c}.200`, 0.8)(theme);
  const lightColor = themeTools.getColor(theme, `${c}.500`);
  const color = themeTools.mode(lightColor, darkColor)(props);
  return {
    color,
    boxShadow: `inset 0 0 0px 1px ${color}`
  };
};
const variantNumber = props => {
  const {
    colorScheme: c,
    theme
  } = props;
  const dark = themeTools.transparentize(`${c}.500`, 0.6)(theme);
  return {
    bg: themeTools.mode(`${c}.500`, dark)(props),
    color: themeTools.mode(`white`, `whiteAlpha.800`)(props),
    borderRadius: 'full',
    border: '1px',
    borderColor: 'white',
    minWidth: '21.5px',
    boxShadow: 'base',
    textAlign: 'center'
  };
};
const variants$3 = {
  solid: variantSolid$1,
  subtle: variantSubtle,
  outline: variantOutline$2,
  number: variantNumber
};
const defaultProps$a = {
  variant: 'subtle',
  colorScheme: 'stone'
};
const Badge = {
  baseStyle: baseStyle$d,
  variants: variants$3,
  defaultProps: defaultProps$a
};

var objectDefineProperties = {};

var DESCRIPTORS$1 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$4 = anObject$7;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$1 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$4(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$3;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$3 = anObject$7;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$3(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$6 = wellKnownSymbol$8;
var create$1 = objectCreate;
var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$6('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$1(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $$1 = _export;
var $includes = arrayIncludes.includes;
var fails$3 = fails$d;
var addToUnscopables$1 = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$3(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$1({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

// style object for base or default style
const baseStyle$c = {
  borderRadius: 'button',
  fontWeight: 'bold',
  _focus: 'none',
  _disabled: {
    opacity: 1,
    cursor: 'not-allowed',
    boxShadow: 'none',
    border: 'none',
    color: '#A6A6A6',
    bg: 'neutral.50'
  },
  _hover: {
    _disabled: {
      color: '#A6A6A6',
      bg: 'neutral.50',
      borderColor: '#A6A6A6'
    }
  }
};
const variantGhost = props => {
  const {
    colorScheme: c
  } = props;
  if (['brand', 'secondary', 'stone'].includes(c)) {
    return {
      fontWeight: 'bold',
      color: `button.outline.${c}.fg.default`,
      bg: 'transparent',
      _disabled: {
        bg: `neutral.50`,
        color: '#A6A6A6'
      },
      _hover: {
        bg: `button.outline.${c}.bg.hover`,
        color: `button.outline.${c}.fg.hover`
      },
      _active: {
        borderColor: `${c}.600`,
        bg: `button.outline.${c}.bg.pressed`,
        color: `button.outline.${c}.fg.pressed`
      }
    };
  }
  return react.theme.components.Button.variants.ghost(props);
};
const variantOutline$1 = props => {
  const {
    colorScheme: c
  } = props;
  const ghostProps = variantGhost(props);
  const borderWith = 1.5;
  const borderColor = {
    default: react.cssVar(`chakra-colors-button-outline-${c}-border-default`).reference,
    hover: react.cssVar(`chakra-colors-button-outline-${c}-border-hover`).reference,
    pressed: react.cssVar(`chakra-colors-button-outline-${c}-border-pressed`).reference
  };
  let color = ghostProps.color;
  let hover = {
    bg: ghostProps._hover.bg,
    color: ghostProps._hover.color
  };
  let active = {
    bg: ghostProps._active.bg,
    color: ghostProps._hover.color
  };
  if (['secondary', 'brand', 'stone'].includes(c)) {
    color = `button.outline.${c}.fg.default`;
    hover = {
      bg: `button.outline.${c}.bg.hover`,
      color: `button.outline.${c}.fg.hover`
    };
    active = {
      bg: `button.outline.${c}.bg.pressed`,
      color: `button.outline.${c}.fg.pressed`
    };
  }
  return Object.assign(Object.assign({
    fontWeight: 'normal',
    border: 'none',
    boxShadow: `inset 0 0 0 ${borderWith}px ${borderColor.default}`
  }, ghostProps), {
    color,
    _hover: {
      bg: hover.bg,
      color: hover.color,
      boxShadow: `inset 0 0 0 ${borderWith}px ${borderColor.hover}`
    },
    _active: {
      bg: active.bg,
      color: active.color,
      boxShadow: `inset 0 0 0 ${borderWith}px ${borderColor.pressed}`
    },
    _disabled: {
      border: `${borderWith}px solid ${ghostProps._disabled.color}`,
      _hover: {
        boxShadow: 'none'
      }
    }
  });
};
const variantSolid = props => {
  const {
    colorScheme: c
  } = props;
  if (['brand', 'secondary'].includes(c)) {
    return {
      bg: `button.solid.${c}.bg.default`,
      color: `button.solid.${c}.fg.default`,
      _hover: {
        bg: `button.solid.${c}.bg.hover`,
        color: `button.solid.${c}.fg.hover`,
        _disabled: {
          color: '#A6A6A6',
          bg: 'neutral.50'
        }
      },
      _active: {
        bg: `button.solid.${c}.bg.pressed`,
        color: `button.solid.${c}.fg.pressed`
      }
    };
  }
  return react.theme.components.Button.variants.solid(props);
};
const variantLink = props => {
  const {
    colorScheme: c
  } = props;
  return {
    padding: 0,
    height: 'auto',
    lineHeight: 'normal',
    fontWeight: 'bold',
    verticalAlign: 'baseline',
    color: ['brand', 'secondary'].includes(c) ? `button.link.${c}.fg.default` : `${c}.500`,
    textDecoration: 'underline',
    textUnderlineOffset: '4px',
    _disabled: {
      bg: 'transparent'
    },
    _hover: {
      color: ['brand', 'secondary'].includes(c) ? `button.link.${c}.fg.hover` : `${c}.700`,
      _disabled: {
        textDecoration: 'underline',
        bg: 'none'
      }
    },
    _active: {
      color: ['brand', 'secondary'].includes(c) ? `button.link.${c}.fg.pressed` : `${c}.700`
    }
  };
};
// styles for different visual variants ("outline", "solid")
const variants$2 = {
  ghost: variantGhost,
  outline: variantOutline$1,
  solid: variantSolid,
  link: variantLink
};
// styles for different sizes ("sm", "md", "lg")
const sizes$9 = {
  lg: {
    h: '44px',
    minW: '44px',
    fontSize: 'lg',
    px: 8
  },
  md: {
    h: '40px',
    minW: '40px',
    fontSize: 'md',
    px: 8
  },
  sm: {
    h: '32px',
    minW: '32px',
    fontSize: 'sm',
    px: 8
  },
  xs: {
    h: '24px',
    minW: '26px',
    fontSize: 'xs',
    px: 6
  }
};
// default values for `size` and `variant`
const defaultProps$9 = {
  variant: 'solid',
  size: 'md',
  colorScheme: 'brand'
};
const Button = {
  baseStyle: baseStyle$c,
  sizes: sizes$9,
  variants: variants$2,
  defaultProps: defaultProps$9
};

var iterators = {};

var fails$2 = fails$d;

var correctPrototypeGetter = !fails$2(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$2 = hasOwnProperty_1;
var isCallable$4 = isCallable$f;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$1 = fails$d;
var isCallable$3 = isCallable$f;
var isObject = isObject$6;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$4;
var wellKnownSymbol$5 = wellKnownSymbol$8;

var ITERATOR$2 = wellKnownSymbol$5('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails$1(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$2[ITERATOR$2])) {
  defineBuiltIn$2(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$4 = wellKnownSymbol$8;

var TO_STRING_TAG$3 = wellKnownSymbol$4('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$3)) {
    defineProperty$1(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis = functionUncurryThis;
var aCallable = aCallable$2;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isCallable$2 = isCallable$f;

var $String$1 = String;
var $TypeError = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$2(argument)) return argument;
  throw $TypeError("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$2 = anObject$7;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$2(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $ = _export;
var call$1 = functionCall;
var FunctionName = functionName;
var isCallable$1 = isCallable$f;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$4;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$3 = wellKnownSymbol$8;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$3('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$1(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$1 = global$c;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$4;
var wellKnownSymbol$2 = wellKnownSymbol$8;

var ITERATOR = wellKnownSymbol$2('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$2('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$1[COLLECTION_NAME] && global$1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const parts$1 = themeTools.anatomy('steps').parts('container', 'body', 'header', 'footer');
const baseStyle$b = props => {
  return {
    container: {
      backgroundColor: themeTools.mode('white', 'gray.800')(props),
      boxShadow: 'base',
      borderRadius: '1rem',
      color: themeTools.mode('gray.800', 'whiteAlpha.900')(props),
      borderColor: themeTools.mode('gray.200', 'whiteAlpha.300')(props)
    },
    body: {
      flex: '1 1 0%'
    },
    header: {
      borderTopRadius: '1rem'
    },
    footer: {
      borderBottomRadius: '1rem'
    }
  };
};
const sizes$8 = {
  sm: {
    body: {
      padding: '3'
    },
    header: {
      padding: '3'
    },
    footer: {
      padding: '3'
    }
  },
  md: {
    body: {
      padding: '5'
    },
    header: {
      padding: '5'
    },
    footer: {
      padding: '5'
    }
  },
  lg: {
    body: {
      padding: '7'
    },
    header: {
      padding: '7'
    },
    footer: {
      padding: '7'
    }
  }
};
const variants$1 = {
  elevated: {
    container: {
      shadow: 'base',
      _dark: {
        backgroundColor: 'gray.700'
      }
    }
  },
  outline: props => ({
    container: {
      shadow: 'none',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: themeTools.mode(`gray.200`, `whiteAlpha.300`)(props)
    }
  }),
  filled: props => ({
    container: {
      shadow: 'none',
      backgroundColor: themeTools.mode('gray.50', 'gray.700')(props)
    }
  }),
  unstyled: {
    container: {
      shadow: 'none'
    },
    body: {
      padding: 0
    },
    header: {
      padding: 0
    },
    footer: {
      padding: 0
    }
  }
};
const defaultProps$8 = {
  variant: 'elevated',
  size: 'md'
};
const Card = {
  parts: parts$1.keys,
  baseStyle: baseStyle$b,
  variants: variants$1,
  sizes: sizes$8,
  defaultProps: defaultProps$8
};

const baseStyleControl$1 = props => {
  const {
    colorScheme: c
  } = props;
  return {
    w: '100%',
    border: '1px',
    borderRadius: 'xs',
    borderColor: 'gray.300',
    _indeterminate: {
      bg: 'white',
      borderColor: 'gray.300',
      color: themeTools.mode(`${c}.100`, `${c}.200`)(props)
    },
    _disabled: {
      borderColor: 'gray.300',
      bg: 'gray.50',
      pointerEvents: 'none'
    },
    _focus: {
      boxShadow: 'none'
    },
    _hover: {
      borderColor: `checkbox.${c}.border.hover`,
      bg: 'gray.100'
    },
    _active: {
      borderColor: `checkbox.${c}.border.pressed`,
      bg: 'gray.200'
    }
  };
};
const baseStyleContainer = {
  _disabled: {
    cursor: 'not-allowed',
    bg: 'none'
  }
};
const baseStyleLabel$1 = {
  userSelect: 'none',
  _disabled: {
    opacity: 0.4
  }
};
const baseStyleIcon$1 = props => {
  const {
    colorScheme: c
  } = props;
  return {
    transitionProperty: 'transform',
    transitionDuration: 'normal',
    borderRadius: 'xs',
    _hover: {
      bg: `checkbox.${c}.bg.hover`,
      borderColor: `checkbox.${c}.bg.hover`
    },
    _active: {
      bg: `checkbox.${c}.bg.pressed`,
      borderColor: `checkbox.${c}.bg.pressed`
    }
  };
};
const baseStyle$a = props => ({
  icon: baseStyleIcon$1(props),
  container: baseStyleContainer,
  control: baseStyleControl$1(props),
  label: baseStyleLabel$1
});
const sizes$7 = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: 'sm'
    },
    icon: {
      fontSize: '0.85rem'
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: 'md'
    },
    icon: {
      fontSize: '1.rem'
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'lg'
    },
    icon: {
      fontSize: '1.65rem'
    }
  }
};
const defaultProps$7 = {
  size: 'lg',
  colorScheme: 'secondary'
};
const Checkbox = {
  parts: anatomy.checkboxAnatomy.keys,
  baseStyle: baseStyle$a,
  sizes: sizes$7,
  defaultProps: defaultProps$7
};

const baseStyle$9 = {
  field: {
    width: '100%',
    minWidth: 0,
    outline: 0,
    position: 'relative',
    appearance: 'none',
    transitionProperty: 'common',
    transitionDuration: 'normal',
    _placeholder: {
      color: 'gray.400'
    }
  }
};
const size = {
  lg: {
    fontSize: 'lg',
    px: 4,
    h: '50px',
    borderRadius: 'md'
  },
  md: {
    fontSize: 'md',
    px: 4,
    h: '44px',
    borderRadius: 'md'
  },
  sm: {
    fontSize: 'sm',
    px: 3,
    h: '32px',
    borderRadius: 'md'
  },
  xs: {
    fontSize: 'xs',
    px: 2,
    h: '24px',
    borderRadius: 'md'
  }
};
const sizes$6 = {
  lg: {
    field: size.lg,
    addon: size.lg
  },
  md: {
    field: size.md,
    addon: size.md
  },
  sm: {
    field: size.sm,
    addon: size.sm
  },
  xs: {
    field: size.xs,
    addon: size.xs
  }
};
function getDefaults(props) {
  const {
    focusBorderColor: fc,
    errorBorderColor: ec,
    fieldBorderColor: fbc,
    disabledColor: dc
  } = props;
  return {
    focusBorderColor: fc || themeTools.mode('secondary.700', 'secondary.300')(props),
    errorBorderColor: ec || themeTools.mode('#DB371F', 'red.300')(props),
    fieldBorderColor: fbc || themeTools.mode('gray.400', 'gray.200')(props),
    disabledColor: dc || themeTools.mode('gray.300', 'gray.100')(props)
  };
}
const variantOutline = props => {
  const {
    theme
  } = props;
  const {
    focusBorderColor: fc,
    errorBorderColor: ec,
    fieldBorderColor: fbc,
    disabledColor: dc
  } = getDefaults(props);
  return {
    field: {
      border: '0.5px solid',
      borderColor: themeTools.getColor(theme, fbc),
      bg: 'inherit',
      _hover: {
        borderColor: themeTools.getColor(theme, fbc)
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
        borderColor: themeTools.getColor(theme, dc),
        boxShadow: `0 0 0 0.5px ${themeTools.getColor(theme, dc)}`,
        _hover: {
          borderColor: themeTools.getColor(theme, dc)
        },
        _placeholder: {
          color: themeTools.getColor(theme, dc)
        }
      },
      _invalid: {
        borderColor: themeTools.getColor(theme, ec),
        boxShadow: `0 0 0 0.5px ${themeTools.getColor(theme, ec)}`
      },
      _focus: {
        zIndex: 1,
        borderColor: themeTools.getColor(theme, fc),
        boxShadow: `0 0 0 0.5px ${themeTools.getColor(theme, fc)}`
      }
    },
    addon: {
      border: '0.5px solid',
      borderColor: themeTools.getColor(theme, fbc),
      bg: themeTools.mode('gray.100', 'whiteAlpha.300')(props)
    }
  };
};
const variantFilled = props => {
  const {
    theme
  } = props;
  const {
    focusBorderColor: fc,
    errorBorderColor: ec,
    disabledColor: dc
  } = getDefaults(props);
  return {
    field: {
      border: '1px solid',
      borderColor: 'transparent',
      bg: themeTools.mode('gray.100', 'whiteAlpha.50')(props),
      _hover: {
        bg: themeTools.mode('gray.100', 'whiteAlpha.50')(props)
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
        bg: themeTools.getColor(theme, dc),
        _placeholder: {
          color: themeTools.mode('gray.700', 'whiteAlpha.100')(props)
        },
        _hover: {
          bg: themeTools.getColor(theme, dc)
        }
      },
      _invalid: {
        borderColor: themeTools.getColor(theme, ec)
      },
      _focus: {
        bg: 'transparent',
        borderColor: themeTools.getColor(theme, fc)
      }
    },
    addon: {
      border: '1px solid',
      borderColor: 'transparent',
      bg: themeTools.mode('gray.100', 'whiteAlpha.50')(props)
    }
  };
};
const variantFlushed = props => {
  const {
    theme
  } = props;
  const {
    focusBorderColor: fc,
    errorBorderColor: ec,
    fieldBorderColor: fbc,
    disabledColor: dc
  } = getDefaults(props);
  return {
    field: {
      borderBottom: '0px solid',
      borderColor: themeTools.getColor(theme, fbc),
      borderRadius: 0,
      px: 0,
      boxShadow: `0px 1px 0px ${themeTools.getColor(theme, fbc)}`,
      bg: 'transparent',
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all'
      },
      _invalid: {
        borderColor: themeTools.getColor(theme, ec),
        boxShadow: `0px 1px 0px ${themeTools.getColor(theme, ec)}`
      },
      _focus: {
        borderColor: themeTools.getColor(theme, fc),
        boxShadow: `0px 1px 0px ${themeTools.getColor(theme, fc)}`
      },
      _disabled: {
        borderColor: themeTools.getColor(theme, dc),
        boxShadow: `0px 1px 0px ${themeTools.getColor(theme, dc)}`,
        _placeholder: {
          color: themeTools.getColor(theme, dc)
        }
      }
    },
    addon: {
      borderBottom: '0px solid',
      borderColor: themeTools.getColor(theme, fbc),
      boxShadow: `0px 1px 0px ${themeTools.getColor(theme, fbc)}`,
      borderRadius: 0,
      px: 0,
      pr: 2,
      bg: 'transparent'
    }
  };
};
const variantUnstyled = {
  field: {
    bg: 'transparent',
    px: 0,
    height: 'auto',
    _disabled: {
      _placeholder: {
        color: 'gray.300'
      }
    }
  },
  addon: {
    bg: 'transparent',
    px: 0,
    height: 'auto'
  }
};
const variants = {
  outline: variantOutline,
  filled: variantFilled,
  flushed: variantFlushed,
  unstyled: variantUnstyled
};
const defaultProps$6 = {
  size: 'sm',
  variant: 'flushed'
};
const Input = {
  parts: anatomy.inputAnatomy.keys,
  baseStyle: baseStyle$9,
  sizes: sizes$6,
  variants,
  defaultProps: defaultProps$6
};

const baseStyleList = props => {
  return {
    bg: themeTools.mode('#fff', 'gray.700')(props),
    boxShadow: themeTools.mode('sm', 'dark-lg')(props),
    color: 'inherit',
    minW: '3xs',
    py: '2',
    zIndex: 1,
    borderRadius: 'md',
    borderWidth: '1px'
  };
};
const baseStyleItem = props => {
  return {
    py: '0.4rem',
    px: '0.8rem',
    transitionProperty: 'background',
    transitionDuration: 'ultra-fast',
    transitionTimingFunction: 'ease-in',
    fontSize: 'xxs',
    _focus: {
      bg: themeTools.mode('gray.100', 'whiteAlpha.100')(props)
    },
    _active: {
      bg: themeTools.mode('gray.200', 'whiteAlpha.200')(props)
    },
    _expanded: {
      bg: themeTools.mode('gray.100', 'whiteAlpha.100')(props)
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed'
    }
  };
};
const baseStyleGroupTitle = {
  mx: 4,
  my: 2,
  fontWeight: 'semibold',
  fontSize: 'sm'
};
const baseStyleCommand = {
  opacity: 0.6
};
const baseStyleDivider = {
  border: 0,
  borderBottom: '1px solid',
  borderColor: 'inherit',
  my: '0.5rem',
  opacity: 0.6
};
const baseStyleButton = {
  transitionProperty: 'common',
  transitionDuration: 'normal'
};
const baseStyle$8 = props => ({
  button: baseStyleButton,
  list: baseStyleList(props),
  item: baseStyleItem(props),
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider
});
const Menu = {
  parts: anatomy.menuAnatomy.keys,
  baseStyle: baseStyle$8
};

const baseStyleOverlay = {
  bg: 'rgba(51, 51, 51, 0.7)',
  zIndex: 'modal'
};
const baseStyleDialogContainer = props => {
  const {
    isCentered,
    scrollBehavior
  } = props;
  return {
    display: 'flex',
    zIndex: 'modal',
    justifyContent: 'center',
    alignItems: isCentered ? 'center' : 'flex-start',
    overflow: scrollBehavior === 'inside' ? 'hidden' : 'auto',
    fontSize: 'sm'
  };
};
const baseStyleDialog = props => {
  const {
    scrollBehavior
  } = props;
  return {
    borderRadius: '12px',
    bg: themeTools.mode('white', 'gray.700')(props),
    color: 'inherit',
    my: '3.75rem',
    zIndex: 'modal',
    maxH: scrollBehavior === 'inside' ? 'calc(100% - 7.5rem)' : undefined,
    boxShadow: themeTools.mode('lg', 'dark-lg')(props)
  };
};
const baseStyleHeader$1 = {
  px: {
    base: 5,
    lg: '36px'
  },
  pb: 2,
  pt: {
    base: 4,
    lg: 5
  },
  fontSize: {
    base: 'md',
    lg: 'lg'
  },
  fontWeight: 'normal'
};
const baseStyleCloseButton$1 = {
  position: 'absolute',
  top: {
    base: 4,
    lg: '24px'
  },
  right: {
    base: 4,
    lg: '36px'
  },
  insetEnd: 2,
  color: 'gray.500',
  boxSize: '24px',
  fontSize: '15px',
  _focus: {
    boxShadow: 'none'
  }
};
const baseStyleBody$1 = props => {
  const {
    scrollBehavior
  } = props;
  return {
    px: {
      base: 5,
      lg: '36px'
    },
    py: 3,
    flex: 1,
    overflow: scrollBehavior === 'inside' ? 'auto' : undefined,
    fontSize: {
      base: 'xs',
      lg: 'sm'
    }
  };
};
const baseStyleFooter$1 = props => {
  return {
    px: {
      base: 5,
      lg: '36px'
    },
    pt: 5,
    pb: {
      base: 10,
      lg: 5
    },
    borderBottomRadius: 'md'
  };
};
const baseStyle$7 = props => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer(props),
  dialog: baseStyleDialog(props),
  header: baseStyleHeader$1,
  closeButton: baseStyleCloseButton$1,
  body: baseStyleBody$1(props),
  footer: baseStyleFooter$1()
});
/**
 * Since the `maxWidth` prop references theme.sizes internally,
 * we can leverage that to size our modals.
 */
function getSize(value) {
  if (value === 'full') {
    return {
      dialog: {
        maxW: '100vw',
        minH: '100vh',
        '@supports(min-height: -webkit-fill-available)': {
          minH: '-webkit-fill-available'
        },
        my: 0
      }
    };
  }
  return {
    dialog: {
      maxW: value
    }
  };
}
const sizes$5 = {
  xs: getSize('xs'),
  sm: getSize('sm'),
  md: getSize('md'),
  lg: getSize('lg'),
  xl: getSize('xl'),
  '2xl': getSize('2xl'),
  '3xl': getSize('3xl'),
  '4xl': getSize('4xl'),
  '5xl': getSize('5xl'),
  '6xl': getSize('6xl'),
  full: getSize('full')
};
const defaultProps$5 = {
  size: 'md',
  autoFocus: false
};
const Modal = {
  parts: anatomy.modalAnatomy.keys,
  baseStyle: baseStyle$7,
  sizes: sizes$5,
  defaultProps: defaultProps$5
};

const $popperBg = themeTools.cssVar('popper-bg');
const $arrowBg$1 = themeTools.cssVar('popper-arrow-bg');
const $arrowShadowColor = themeTools.cssVar('popper-arrow-shadow-color');
const $arrowSize = themeTools.cssVar('popper-arrow-size');
const baseStylePopper = {
  zIndex: 10
};
const baseStyleContent = props => {
  const bg = themeTools.mode('neutral.900', 'white')(props);
  const shadowColor = themeTools.mode('gray.200', 'whiteAlpha.300')(props);
  const color = themeTools.mode('white', 'gray.800')(props);
  return {
    [$popperBg.variable]: `colors.${bg}`,
    bg: $popperBg.reference,
    [$arrowBg$1.variable]: $popperBg.reference,
    [$arrowShadowColor.variable]: `colors.${shadowColor}`,
    [$arrowSize.variable]: '18px',
    border: '1px solid',
    borderColor: 'gray.300',
    borderRadius: 'sm',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    zIndex: 'inherit',
    minWidth: '260px',
    maxWidth: '320px',
    maxHeight: '260px',
    fontSize: 'xs',
    color: color,
    p: 4,
    _focus: {
      outline: 0,
      boxShadow: 'node'
    }
  };
};
const baseStyleHeader = {
  borderStyle: 'none',
  fontWeight: 'bold',
  px: 0,
  pt: 0,
  pb: 2
};
const baseStyleBody = {
  p: 0
};
const baseStyleFooter = {
  px: 0,
  pt: 4,
  pb: 0,
  borderStyle: 'none'
};
const baseStyleCloseButton = {
  position: 'absolute',
  borderRadius: 'md',
  top: 4,
  insetEnd: 4,
  color: 'white',
  boxSize: '20px',
  _focus: {
    borderStyle: 'none'
  }
};
const baseStyle$6 = props => ({
  popper: baseStylePopper,
  content: baseStyleContent(props),
  header: baseStyleHeader,
  body: baseStyleBody,
  footer: baseStyleFooter,
  arrow: {},
  closeButton: baseStyleCloseButton
});
const Popover = {
  parts: anatomy.popoverAnatomy.keys,
  baseStyle: baseStyle$6
};

const baseStyleControl = props => {
  const {
    colorScheme: c,
    size
  } = props;
  const {
    control = {}
  } = baseStyle$a(props);
  let dotSize = '12px';
  if (size === 'md') {
    dotSize = '9px';
  } else if (size === 'sm') {
    dotSize = '6px';
  }
  return Object.assign(Object.assign({}, control), {
    borderRadius: 'full',
    _hover: {
      bg: 'gray.100',
      borderColor: `radio.${c}.border.hover`,
      _before: {
        content: `""`,
        display: 'inline-block',
        pos: 'relative',
        w: dotSize,
        h: dotSize,
        borderRadius: '50%'
      },
      _disabled: {
        _hover: {
          borderColor: 'gray.200',
          bg: 'gray.50'
        }
      },
      _active: {
        bg: 'gray.200'
      }
    },
    _checked: {
      bg: 'white',
      borderColor: `radio.${c}.border.default`,
      _before: {
        content: `""`,
        display: 'inline-block',
        pos: 'relative',
        w: dotSize,
        h: dotSize,
        borderRadius: '50%',
        bg: `radio.${c}.bg.default`
      },
      _hover: {
        bg: 'gray.100',
        borderColor: `radio.${c}.border.hover`,
        _before: {
          bg: `radio.${c}.bg.hover`
        },
        _disabled: {
          bg: 'gray.200',
          _before: {
            bg: 'gray.300'
          }
        }
      },
      _disabled: {
        bg: 'gray.50',
        _before: {
          bg: 'gray.300'
        }
      }
    },
    _active: {
      borderColor: `radio.${c}.border.pressed`,
      _disabled: {
        _before: {
          bg: 'gray.50'
        }
      }
    }
  });
};
const baseStyle$5 = props => ({
  label: baseStyle$a(props).label,
  container: baseStyle$a(props).container,
  control: baseStyleControl(props)
});
const sizes$4 = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: 'md'
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'lg'
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: 'sm'
    }
  }
};
const defaultProps$4 = {
  size: 'lg',
  colorScheme: 'secondary'
};
const Radio = {
  parts: anatomy.radioAnatomy.keys,
  baseStyle: baseStyle$5,
  sizes: sizes$4,
  defaultProps: defaultProps$4
};

const fade = (startColor, endColor) => react.keyframes({
  from: {
    borderColor: startColor,
    background: startColor
  },
  to: {
    borderColor: endColor,
    background: endColor
  }
});
const baseStyle$4 = props => {
  const defaultStartColor = themeTools.mode('gray.200', 'gray.800')(props);
  const defaultEndColor = themeTools.mode('gray.300', 'gray.600')(props);
  const {
    startColor = defaultStartColor,
    endColor = defaultEndColor,
    speed,
    theme
  } = props;
  const start = themeTools.getColor(theme, startColor);
  const end = themeTools.getColor(theme, endColor);
  return {
    opacity: 0.7,
    borderRadius: '2px',
    borderColor: start,
    background: end,
    animation: `${speed}s linear infinite alternate ${fade(start, end)}`
  };
};
const defaultProps$3 = {
  baseStyle: baseStyle$4
};
const Skeleton = {
  baseStyle: baseStyle$4,
  defaultProps: defaultProps$3
};

const $size = themeTools.cssVar('spinner-size');
const baseStyle$3 = {
  width: [$size.reference],
  height: [$size.reference]
};
const sizes$3 = {
  xs: {
    [$size.variable]: '0.75rem'
  },
  sm: {
    [$size.variable]: '1rem'
  },
  md: {
    [$size.variable]: '1.5rem'
  },
  lg: {
    [$size.variable]: '2rem'
  },
  xl: {
    [$size.variable]: '3rem'
  },
  '2xl': {
    [$size.variable]: '4rem'
  },
  '3xl': {
    [$size.variable]: '5rem'
  },
  '4xl': {
    [$size.variable]: '6rem'
  }
};
const defaultProps$2 = {
  size: 'md',
  colorScheme: 'stone'
};
const Spinner = {
  baseStyle: baseStyle$3,
  sizes: sizes$3,
  defaultProps: defaultProps$2
};

const parts = themeTools.anatomy('steps').parts('connector', 'description', 'icon', 'iconLabel', 'label', 'labelContainer', 'step', 'stepContainer', 'stepIconContainer', 'steps');
const baseStyleIcon = {
  strokeWidth: '2px'
};
const baseStyleLabel = props => ({
  color: themeTools.mode(`gray.800`, `gray.100`)(props),
  fontWeight: 'medium',
  textAlign: 'center',
  fontSize: 'md',
  _activeStep: {
    color: 'gray.900'
  }
});
const baseStyleDescription = props => ({
  color: themeTools.mode(`gray.800`, `gray.200`)(props),
  marginTop: '-2px',
  textAlign: 'center',
  fontSize: 'sm'
});
const baseStyleConnector = props => {
  const {
    colorScheme: c
  } = props;
  const inactiveColor = themeTools.mode('gray.200', 'gray.700')(props);
  let color = `${c}.500`;
  if (c === 'secondary') {
    color = `${c}.700`;
  }
  const activeColor = themeTools.mode(color, `${c}.200`)(props);
  return {
    flex: 1,
    display: 'flex',
    borderStyle: 'solid',
    borderColor: inactiveColor,
    transitionProperty: 'border-color',
    transitionDuration: 'normal',
    _highlighted: {
      borderColor: activeColor
    }
  };
};
const baseStyleStepIconContainer = props => {
  const {
    colorScheme: c
  } = props;
  const inactiveColor = themeTools.mode('gray.400', 'gray.700')(props);
  let activeColor = `${c}.500`;
  if (c === 'secondary') {
    activeColor = `${c}.700`;
  }
  return {
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    bg: inactiveColor,
    borderStyle: 'solid',
    borderColor: inactiveColor,
    transitionProperty: 'background, border-color',
    transitionDuration: 'normal',
    _activeStep: {
      bg: themeTools.mode(themeTools.darken('white', 0.5), themeTools.lighten(inactiveColor, 0.5))(props),
      borderColor: activeColor,
      _invalid: {
        bg: 'red.500',
        borderColor: 'red.500'
      }
    },
    _highlighted: {
      bg: activeColor,
      borderColor: activeColor
    },
    '&[data-clickable]:hover': {
      borderColor: activeColor
    }
  };
};
const baseStyle$2 = props => {
  const {
    colorScheme: c
  } = props;
  let color = `${c}.500`;
  if (c === 'secondary') {
    color = `${c}.700`;
  }
  return {
    connector: baseStyleConnector(props),
    description: baseStyleDescription(props),
    icon: baseStyleIcon,
    iconLabel: baseStyleLabel(props),
    label: Object.assign(Object.assign({}, baseStyleLabel(props)), {
      _activeStep: {
        color
      }
    }),
    labelContainer: {
      display: 'flex',
      flexDir: 'column',
      justifyContent: 'center'
    },
    step: {
      display: 'flex',
      position: 'relative'
    },
    stepContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    stepIconContainer: baseStyleStepIconContainer(props),
    steps: {
      fontFamily: 'heading',
      textAlign: 'center',
      width: '100%',
      display: 'flex',
      flex: 1
    }
  };
};
const sizes$2 = {
  sm: {
    stepIconContainer: {
      width: '26px',
      height: '26px',
      borderWidth: '2px'
    },
    icon: {
      width: '14px',
      height: '14px'
    },
    label: {
      fontWeight: 'semibold',
      textAlign: 'center',
      fontSize: 'sm'
    },
    description: {
      fontWeight: '300',
      textAlign: 'center',
      fontSize: 'xs'
    }
  },
  md: {
    stepIconContainer: {
      width: '40px',
      height: '40px',
      borderWidth: '2px'
    },
    icon: {
      width: '18px',
      height: '18px'
    },
    label: {
      fontWeight: 'semibold',
      textAlign: 'center',
      fontSize: 'md'
    },
    description: {
      fontWeight: '300',
      textAlign: 'center',
      fontSize: 'sm'
    }
  },
  lg: {
    stepIconContainer: {
      width: '48px',
      height: '48px',
      borderWidth: '2px'
    },
    icon: {
      width: '22px',
      height: '22px'
    },
    label: {
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: 'lg'
    },
    description: {
      fontWeight: '300',
      textAlign: 'center',
      fontSize: 'md'
    }
  }
};
const defaultProps$1 = {
  size: 'md',
  colorScheme: 'brand'
};
const Steps = {
  parts: parts.keys,
  baseStyle: baseStyle$2,
  sizes: sizes$2,
  defaultProps: defaultProps$1
};

var wellKnownSymbol$1 = wellKnownSymbol$8;

var TO_STRING_TAG$1 = wellKnownSymbol$1('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable = isCallable$f;
var classofRaw = classofRaw$1;
var wellKnownSymbol = wellKnownSymbol$8;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var classof = classof$1;

var $String = String;

var toString = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var anObject$1 = anObject$7;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var call = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$4;
var anObject = anObject$7;
var $toString = toString;
var fails = fails$d;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const $width = themeTools.cssVar('switch-track-width');
const $height = themeTools.cssVar('switch-track-height');
const $diff = themeTools.cssVar('switch-track-diff');
const diffValue = themeTools.calc.subtract($width, $height);
const $translateX = themeTools.cssVar('switch-thumb-x');
const baseStyleTrack = props => {
  const {
    colorScheme: c
  } = props;
  return {
    borderRadius: 'full',
    p: '1px',
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: 'common',
    transitionDuration: 'fast',
    bg: themeTools.mode('gray.100', 'whiteAlpha.400')(props),
    _focus: {
      boxShadow: 'none'
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed'
    },
    _checked: {
      bg: themeTools.mode(`${c}.500`, `${c}.200`)(props)
    }
  };
};
const baseStyleThumb = {
  bg: 'white',
  transitionProperty: 'transform',
  transitionDuration: 'normal',
  borderRadius: 'inherit',
  width: [$height.reference],
  height: [$height.reference],
  _checked: {
    transform: `translateX(${$translateX.reference})`
  }
};
const baseStyle$1 = props => ({
  container: {
    [$diff.variable]: diffValue,
    [$translateX.variable]: $diff.reference,
    _rtl: {
      [$translateX.variable]: themeTools.calc($diff).negate().toString()
    }
  },
  track: baseStyleTrack(props),
  thumb: baseStyleThumb
});
const sizes$1 = {
  sm: {
    container: {
      [$width.variable]: '2.8rem',
      [$height.variable]: '1.6rem'
    }
  },
  md: {
    container: {
      [$width.variable]: '3.8rem',
      [$height.variable]: '2.2rem'
    }
  },
  lg: {
    container: {
      // 50x30
      [$width.variable]: '4.8rem',
      [$height.variable]: '2.8rem'
    }
  }
};
const defaultProps = {
  size: 'md',
  colorScheme: 'brand'
};
const Switch = {
  parts: anatomy.switchAnatomy.keys,
  baseStyle: baseStyle$1,
  sizes: sizes$1,
  defaultProps
};

const $bg = themeTools.cssVar('tooltip-bg');
const $arrowBg = themeTools.cssVar('popper-arrow-bg');
const baseStyle = props => {
  const bg = themeTools.mode('white', 'gray.700')(props);
  return {
    [$bg.variable]: `colors.${bg}`,
    bg: [$bg.reference],
    [$arrowBg.variable]: [$bg.reference],
    color: themeTools.mode('gray', 'white')(props),
    px: '8px',
    py: '2px',
    fontWeight: 'normal',
    fontSize: 'xs',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    maxW: '320px',
    zIndex: 'tooltip'
  };
};
const Tooltip = {
  baseStyle
};

var components = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Badge: Badge,
	Button: Button,
	Card: Card,
	baseStyle: baseStyle$a,
	Checkbox: Checkbox,
	Input: Input,
	Menu: Menu,
	Modal: Modal,
	Popover: Popover,
	Radio: Radio,
	Skeleton: Skeleton,
	Spinner: Spinner,
	Steps: Steps,
	Switch: Switch,
	Tooltip: Tooltip
});

const breakpoints = {
  base: '0px',
  xs: '320px',
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1440px'
};

const black = '#1D1D1D';
const white = '#FEFEFF';
const neutral = {
  50: '#F9F9F9',
  100: '#F1F1F1',
  200: '#DDDDDD',
  300: '#A6A6A6',
  400: '#A6A6A6',
  500: '#8B8B8B',
  600: '#717171',
  700: '#505050',
  800: '#404040',
  900: '#333333'
};
const stone = {
  50: '#EDEEF0',
  100: '#D3D7DB',
  200: '#8C969F',
  300: '#495867',
  400: '#3E4B58',
  500: '#343E49',
  600: '#2A323B',
  700: '#21282E',
  800: '#1C2329',
  900: '#0D151C'
};
const colors = {
  black,
  neutral,
  gray: neutral,
  white,
  stone
};

const radii = {
  none: '0',
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  '2xl': '32px',
  full: '80px'
};

const shadows = {
  base: '0.0px 2.0px 2.0px 0px rgba(29, 29, 29, 0.1)',
  raised: '0.0px 0.0px 12.0px 0px rgba(29, 29, 29, 0.2)',
  elevated: '0.0px 4.0px 20.0px 0px rgba(29, 29, 29, 0.2)'
};

const spacing = {
  px: '1px',
  0.5: '0.2rem',
  1: '0.4rem',
  1.5: '0.6rem',
  2: '0.8rem',
  2.5: '1rem',
  3: '1.2rem',
  3.5: '1.4rem',
  4: '1.6rem',
  5: '2rem',
  6: '2.4rem',
  7: '2.8rem',
  8: '3.2rem',
  9: '3.6rem',
  10: '4rem',
  12: '4.8rem',
  14: '5.6rem',
  16: '6.4rem',
  20: '8rem',
  24: '9.6rem',
  28: '11.2rem',
  32: '12.8rem',
  36: '14.4rem',
  40: '16rem',
  44: '17.6rem',
  48: '19.2rem',
  52: '20.8rem',
  56: '22.4rem',
  60: '24rem',
  64: '25.6rem',
  72: '28.8rem',
  80: '32rem',
  96: '38.4rem'
};

const largeSizes = {
  max: 'max-content',
  min: 'min-content',
  full: '100%',
  '3xs': '22.4rem',
  '2xs': '25.6rem',
  xs: '32rem',
  sm: '38.4rem',
  md: '44.8rem',
  lg: '51.2rem',
  xl: '57.6rem',
  '2xl': '67.2rem',
  '3xl': '76.8rem',
  '4xl': '89.6rem',
  '5xl': '102.4rem',
  '6xl': '115.2rem',
  '7xl': '128rem',
  '8xl': '144rem'
};
const container = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px'
};
const sizes = Object.assign(Object.assign(Object.assign({}, spacing), largeSizes), {
  container
});

const typography = {
  letterSpacings: {
    tighter: '-0.05em',
    tight: '-0.025em',
    normal: '0',
    wide: '0.025em',
    wider: '0.05em',
    widest: '0.1em'
  },
  lineHeights: {
    normal: 'normal',
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: '2',
    '3': '.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '9': '2.25rem',
    '10': '2.5rem'
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: `Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
  },
  fontSizes: {
    xxs: '1.3rem',
    xs: '1.4rem',
    sm: '1.6rem',
    md: '1.8rem',
    lg: '2.0rem',
    xl: '2.2rem',
    '2xl': '2.4rem',
    '3xl': '3.2rem',
    '4xl': '3.6rem',
    '5xl': '4.8rem',
    '6xl': '6rem',
    '7xl': '7.2rem',
    '8xl': '9.6rem',
    '9xl': '12.8rem'
  }
};

const foundations = Object.assign(Object.assign({
  radii,
  colors
}, typography), {
  sizes,
  space: spacing,
  shadows,
  breakpoints
});

const styles = {
  global: props => ({
    html: {
      fontSize: '10px'
    },
    'html, body, #__next': {
      height: '100vh',
      bg: themeTools.mode('white', 'gray.800')(props)
    }
  })
};

const semanticTokens$6 = {
  colors: {
    button: {
      solid: {
        stone: {
          bg: {
            default: 'stone.500',
            hover: 'stone.400',
            pressed: 'stone.300'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        stone: {
          bg: {
            default: 'white',
            hover: 'stone.50',
            pressed: 'stone.100'
          },
          fg: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.500'
          },
          border: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.500'
          }
        }
      },
      link: {
        stone: {
          fg: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.400'
          }
        }
      }
    }
  }
};

const theme = react.extendTheme(Object.assign(Object.assign({}, foundations), {
  components: Object.assign({}, components),
  styles,
  semanticTokens: flattenObject(semanticTokens$6)
}));

const midnight = {
  50: '#E6ECF1',
  100: '#C2D1DE',
  200: '#91ADC4',
  300: '#5E87A8',
  400: '#2E638E',
  500: '#004175',
  600: '#003763',
  700: '#002E53',
  800: '#002543',
  900: '#001D35'
};

const semanticTokens$5 = {
  radii: {
    button: '4px'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'midnight.500',
            hover: 'midnight.600',
            pressed: 'midnight.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        },
        secondary: {
          bg: {
            default: 'stone.500',
            hover: 'stone.400',
            pressed: 'stone.300'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'midnight.500',
            hover: 'midnight.50',
            pressed: 'midnight.100'
          },
          fg: {
            default: 'midnight.500',
            hover: 'midnight.500',
            pressed: 'midnight.500'
          },
          border: {
            default: 'midnight.500',
            hover: 'midnight.500',
            pressed: 'midnight.500'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'stone.50',
            pressed: 'stone.100'
          },
          fg: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.500'
          },
          border: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.500'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'midnight.500',
            hover: 'midnight.500',
            pressed: 'midnight.800'
          }
        },
        secondary: {
          fg: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.400'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'midnight.500',
          hover: 'midnight.600',
          pressed: 'midnight.700'
        },
        border: {
          default: 'midnight.500',
          hover: 'midnight.600',
          pressed: 'midnight.700'
        }
      },
      secondary: {
        bg: {
          default: 'midnight.500',
          hover: 'midnight.600',
          pressed: 'midnight.700'
        },
        border: {
          default: 'stone.500',
          hover: 'midnight.500',
          pressed: 'midnight.600'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.600',
          pressed: 'brand.700'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.600',
          pressed: 'brand.700'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.600',
          pressed: 'secondary.700'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.600',
          pressed: 'secondary.700'
        }
      }
    }
  }
};

const b2b = react.extendTheme({
  colors: {
    midnight,
    brand: midnight,
    secondary: midnight
  },
  semanticTokens: flattenObject(semanticTokens$5)
}, theme);

const sunshine = {
  50: '#FFFBE6',
  100: '#FEF5C2',
  200: '#FDED91',
  300: '#FCE55E',
  400: '#FCDD2E',
  500: '#FBD600',
  600: '#D5B600',
  700: '#B29800',
  800: '#8F7A00',
  900: '#716000'
};
const mist = {
  50: '#EBEBEB',
  100: '#CECECE',
  200: '#A7A7A7',
  300: '#7E7E7E',
  400: '#585858',
  500: '#333333',
  600: '#2B2B2B',
  700: '#242424',
  800: '#1D1D1D',
  900: '#171717'
};

const semanticTokens$4 = {
  radii: {
    button: '4px'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'sunshine.500',
            hover: 'sunshine.600',
            pressed: 'sunshine.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        },
        secondary: {
          bg: {
            default: 'sunshine.500',
            hover: 'sunshine.600',
            pressed: 'sunshine.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'white',
            hover: 'sunshine.50',
            pressed: 'sunshine.100'
          },
          fg: {
            default: 'sunshine.500',
            hover: 'sunshine.500',
            pressed: 'sunshine.500'
          },
          border: {
            default: 'sunshine.500',
            hover: 'sunshine.500',
            pressed: 'sunshine.500'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'sunshine.50',
            pressed: 'sunshine.100'
          },
          fg: {
            default: 'sunshine.500',
            hover: 'sunshine.500',
            pressed: 'sunshine.500'
          },
          border: {
            default: 'sunshine.500',
            hover: 'sunshine.500',
            pressed: 'sunshine.500'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'sunshine.500',
            hover: 'sunshine.500',
            pressed: 'sunshine.800'
          }
        },
        secondary: {
          fg: {
            default: 'sunshine.500',
            hover: 'sunshine.500',
            pressed: 'sunshine.800'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'sunshine.500',
          hover: 'sunshine.600',
          pressed: 'sunshine.700'
        },
        border: {
          default: 'sunshine.500',
          hover: 'sunshine.600',
          pressed: 'sunshine.700'
        }
      },
      secondary: {
        bg: {
          default: 'mist.500',
          hover: 'mist.400',
          pressed: 'mist.300'
        },
        border: {
          default: 'mist.500',
          hover: 'mist.500',
          pressed: 'mist.400'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        }
      }
    }
  }
};

const constructor = react.extendTheme({
  colors: {
    sunshine,
    mist,
    brand: sunshine,
    secondary: mist
  },
  semanticTokens: flattenObject(semanticTokens$4)
}, theme);

const lime = {
  50: '#F7FBE6',
  100: '#EBF5C2',
  200: '#DCED91',
  300: '#CBE55E',
  400: '#BCDD2E',
  500: '#ADD500',
  600: '#93B500',
  700: '#7B9700',
  800: '#637900',
  900: '#4E6000'
};

const semanticTokens$3 = {
  radii: {
    button: '4px'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'lime.500',
            hover: 'lime.600',
            pressed: 'lime.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        },
        secondary: {
          bg: {
            default: 'lime.500',
            hover: 'lime.600',
            pressed: 'lime.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'white',
            hover: 'lime.50',
            pressed: 'lime.100'
          },
          fg: {
            default: 'lime.500',
            hover: 'lime.500',
            pressed: 'lime.500'
          },
          border: {
            default: 'lime.500',
            hover: 'lime.500',
            pressed: 'lime.500'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'lime.50',
            pressed: 'lime.100'
          },
          fg: {
            default: 'lime.500',
            hover: 'lime.500',
            pressed: 'lime.500'
          },
          border: {
            default: 'lime.500',
            hover: 'lime.500',
            pressed: 'lime.500'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'lime.500',
            hover: 'lime.500',
            pressed: 'lime.800'
          }
        },
        secondary: {
          fg: {
            default: 'lime.500',
            hover: 'lime.500',
            pressed: 'lime.800'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'lime.500',
          hover: 'lime.600',
          pressed: 'lime.700'
        },
        border: {
          default: 'lime.500',
          hover: 'lime.600',
          pressed: 'lime.700'
        }
      },
      secondary: {
        bg: {
          default: 'stone.500',
          hover: 'stone.400',
          pressed: 'stone.300'
        },
        border: {
          default: 'stone.500',
          hover: 'stone.500',
          pressed: 'stone.400'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        }
      }
    }
  }
};

const falabella = react.extendTheme({
  colors: {
    lime,
    brand: lime,
    secondary: theme.colors.stone
  },
  semanticTokens: flattenObject(semanticTokens$3)
}, theme);

const semanticTokens$2 = {
  radii: {
    button: '50vh'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'brand.500',
            hover: 'brand.400',
            pressed: 'brand.300'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        },
        secondary: {
          bg: {
            default: 'secondary.500',
            hover: 'secondary.400',
            pressed: 'secondary.300'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'white',
            hover: 'brand.50',
            pressed: 'brand.100'
          },
          fg: {
            default: 'brand.500',
            hover: 'brand.500',
            pressed: 'brand.500'
          },
          border: {
            default: 'brand.500',
            hover: 'brand.500',
            pressed: 'brand.500'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'secondary.50',
            pressed: 'secondary.100'
          },
          fg: {
            default: 'secondary.500',
            hover: 'secondary.500',
            pressed: 'secondary.500'
          },
          border: {
            default: 'secondary.500',
            hover: 'secondary.500',
            pressed: 'secondary.500'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'brand.500',
            hover: 'brand.500',
            pressed: 'brand.400'
          }
        },
        secondary: {
          fg: {
            default: 'secondary.500',
            hover: 'secondary.500',
            pressed: 'secondary.400'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.500',
          pressed: 'secondary.400'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        }
      }
    }
  }
};

const fcom = react.extendTheme({
  colors: {
    brand: theme.colors.stone,
    secondary: theme.colors.stone
  },
  semanticTokens: flattenObject(semanticTokens$2)
}, theme);

const sky = {
  50: '#E6F1FA',
  100: '#C2DDF3',
  200: '#91C2EA',
  300: '#5EA6E0',
  400: '#2E8BD7',
  500: '#0072CE',
  600: '#0061AF',
  700: '#005192',
  800: '#004175',
  900: '#00335D'
};
const scarlet = {
  50: '#FFF0F3',
  100: '#FFDDE4',
  200: '#FFC0CD',
  300: '#FF94A9',
  400: '#EA5E73',
  500: '#DD0021',
  600: '#BC001C',
  700: '#9D0017',
  800: '#7E0013',
  900: '#63000F'
};

const semanticTokens$1 = {
  radii: {
    button: '4px'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'sky.500',
            hover: 'sky.600',
            pressed: 'sky.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        },
        secondary: {
          bg: {
            default: 'stone.500',
            hover: 'stone.400',
            pressed: 'stone.300'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'sky.500',
            hover: 'sky.50',
            pressed: 'sky.100'
          },
          fg: {
            default: 'sky.500',
            hover: 'sky.500',
            pressed: 'sky.500'
          },
          border: {
            default: 'sky.500',
            hover: 'sky.500',
            pressed: 'sky.500'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'stone.50',
            pressed: 'stone.100'
          },
          fg: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.500'
          },
          border: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.500'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'sky.500',
            hover: 'sky.500',
            pressed: 'sky.800'
          }
        },
        secondary: {
          fg: {
            default: 'stone.500',
            hover: 'stone.500',
            pressed: 'stone.400'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'sky.500',
          hover: 'sky.600',
          pressed: 'sky.700'
        },
        border: {
          default: 'sky.500',
          hover: 'sky.600',
          pressed: 'sky.700'
        }
      },
      secondary: {
        bg: {
          default: 'stone.500',
          hover: 'stone.400',
          pressed: 'stone.300'
        },
        border: {
          default: 'stone.500',
          hover: 'stone.500',
          pressed: 'stone.400'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.400',
          pressed: 'brand.300'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.400',
          pressed: 'secondary.300'
        }
      }
    }
  }
};
const semanticTokensAlt = {
  radii: {
    button: '4px'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'scarlet.500',
            hover: 'scarlet.600',
            pressed: 'scarlet.800'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        },
        secondary: {
          bg: {
            default: 'sky.500',
            hover: 'sky.600',
            pressed: 'sky.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'scarlet.500',
            hover: 'scarlet.600',
            pressed: 'scarlet.800'
          },
          fg: {
            default: 'scarlet.500',
            hover: 'white',
            pressed: 'white'
          },
          border: {
            default: 'scarlet.500',
            hover: 'scarlet.600',
            pressed: 'scarlet.800'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'sky.600',
            pressed: 'sky.800'
          },
          fg: {
            default: 'sky.500',
            hover: 'white',
            pressed: 'white'
          },
          border: {
            default: 'sky.500',
            hover: 'sky.600',
            pressed: 'sky.800'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'scarlet.500',
            hover: 'scarlet.500',
            pressed: 'scarlet.800'
          }
        },
        secondary: {
          fg: {
            default: 'sky.500',
            hover: 'sky.500',
            pressed: 'sky.800'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'scarlet.500',
          hover: 'scarlet.600',
          pressed: 'scarlet.800'
        },
        border: {
          default: 'scarlet.500',
          hover: 'scarlet.600',
          pressed: 'scarlet.800'
        }
      },
      secondary: {
        bg: {
          default: 'sky.500',
          hover: 'sky.600',
          pressed: 'sky.700'
        },
        border: {
          default: 'sky.500',
          hover: 'sky.500',
          pressed: 'sky.600'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.600',
          pressed: 'brand.700'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.600',
          pressed: 'brand.700'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.600',
          pressed: 'secondary.700'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.600',
          pressed: 'secondary.700'
        }
      }
    }
  }
};

const sodimac = react.extendTheme({
  colors: {
    sky,
    brand: sky,
    secondary: theme.colors.stone
  },
  semanticTokens: flattenObject(semanticTokens$1)
}, theme);
const sodimacAlt = react.extendTheme({
  colors: {
    sky,
    scarlet,
    brand: scarlet,
    secondary: sky
  },
  semanticTokens: flattenObject(semanticTokensAlt)
}, theme);

const mint = {
  50: '#EFFEF3',
  100: '#DAFEE3',
  200: '#B8FAC9',
  300: '#80F5A0',
  400: '#41E770',
  500: '#19CE4D',
  600: '#0DA137',
  700: '#116A2B',
  800: '#105726',
  900: '#033012'
};
const petroleum = {
  50: '#EFFEFD',
  100: '#AEEDF3',
  200: '#76DEEA',
  300: '#07BDC5',
  400: '#03949E',
  500: '#07757E',
  600: '#0B5D64',
  700: '#0E4E53',
  800: '#013F48',
  900: '#02292C'
};

const semanticTokens = {
  radii: {
    button: '50vh'
  },
  colors: {
    button: {
      solid: {
        brand: {
          bg: {
            default: 'mint.500',
            hover: 'mint.600',
            pressed: 'mint.700'
          },
          fg: {
            default: 'pretroleum.800',
            hover: 'pretroleum.800',
            pressed: 'pretroleum.800'
          }
        },
        secondary: {
          bg: {
            default: 'petroleum.500',
            hover: 'petroleum.600',
            pressed: 'petroleum.700'
          },
          fg: {
            default: 'white',
            hover: 'white',
            pressed: 'white'
          }
        }
      },
      outline: {
        brand: {
          bg: {
            default: 'white',
            hover: 'mint.50',
            pressed: 'mint.100'
          },
          fg: {
            default: 'mint.500',
            hover: 'mint.500',
            pressed: 'mint.500'
          },
          border: {
            default: 'mint.500',
            hover: 'mint.500',
            pressed: 'mint.500'
          }
        },
        secondary: {
          bg: {
            default: 'white',
            hover: 'petroleum.50',
            pressed: 'petroleum.100'
          },
          fg: {
            default: 'petroleum.500',
            hover: 'petroleum.500',
            pressed: 'petroleum.500'
          },
          border: {
            default: 'petroleum.800',
            hover: 'petroleum.800',
            pressed: 'petroleum.800'
          }
        }
      },
      link: {
        brand: {
          fg: {
            default: 'mint.500',
            hover: 'mint.500',
            pressed: 'mint.800'
          }
        },
        secondary: {
          fg: {
            default: 'petroleum.500',
            hover: 'petroleum.500',
            pressed: 'petroleum.800'
          }
        }
      }
    },
    checkbox: {
      brand: {
        bg: {
          default: 'mint.500',
          hover: 'mint.600',
          pressed: 'mint.700'
        },
        border: {
          default: 'mint.500',
          hover: 'mint.600',
          pressed: 'mint.700'
        }
      },
      secondary: {
        bg: {
          default: 'petroleum.500',
          hover: 'petroleum.600',
          pressed: 'petroleum.700'
        },
        border: {
          default: 'petroleum.500',
          hover: 'petroleum.500',
          pressed: 'petroleum.600'
        }
      }
    },
    radio: {
      brand: {
        bg: {
          default: 'brand.500',
          hover: 'brand.600',
          pressed: 'brand.700'
        },
        border: {
          default: 'brand.500',
          hover: 'brand.600',
          pressed: 'brand.700'
        }
      },
      secondary: {
        bg: {
          default: 'secondary.500',
          hover: 'secondary.600',
          pressed: 'secondary.700'
        },
        border: {
          default: 'secondary.500',
          hover: 'secondary.600',
          pressed: 'secondary.700'
        }
      }
    }
  }
};

const tottus = react.extendTheme({
  colors: {
    mint,
    petroleum,
    brand: mint,
    secondary: petroleum
  },
  semanticTokens: flattenObject(semanticTokens)
}, theme);

exports.b2b = b2b;
exports.baseTheme = theme;
exports.constructor = constructor;
exports.falabella = falabella;
exports.fcom = fcom;
exports.sodimac = sodimac;
exports.sodimacAlt = sodimacAlt;
exports.tottus = tottus;
